module.exports = __webpack_public_path__ + "img/img3.ace9393e.png";